/** @format */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationService } from '@shared/authentication/data-access';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard  {
	constructor(public authService: AuthenticationService, public router: Router) {}

	canActivate(): Observable<boolean> {
		return this.authService.getIsAuthenticated$().pipe(
			map((loggedIn: boolean) => {
				if (loggedIn) {
					this.router.navigate(['MyAccount', 'AccountSummary']);
				} else {
					this.authService
						.login(
							{
								target: '/LogonRedirect'
							}
						)
						.subscribe();
				}

				return loggedIn;
			})
		);
	}
}
